import React from 'react';
import { IonActionSheet, IonList, IonItem, IonLabel, IonTitle, IonIcon } from '@ionic/react';
import { _dict } from '../constants';
import { camera, grid, images, logoYoutube } from 'ionicons/icons';

type Props = {
  isOpen: boolean;
  onDidDismiss: (source: string | null) => void;
  lang: string;
};

export const ImageSelector: React.FC<Props> = ({ isOpen, onDidDismiss, lang }) => {
  const handleSelect = (value: 'arasaac' | 'unsplash' | 'device' | 'youtube') => {

    onDidDismiss(value);
  };

  return (
    <IonActionSheet
      isOpen={isOpen}
      onDidDismiss={() => onDidDismiss(null)}
      buttons={[
        {
          text: _dict.loadContentFrom[lang],
          role: 'title'
        },
        {
          text: 'Arasaac',
          icon: grid,
          handler: () => handleSelect('arasaac')
        },
        {
          text: 'Unsplash',
          icon: images,
          handler: () => handleSelect('unsplash')
        },
        {
          text: _dict.thisDevice[lang],
          icon: camera,
          handler: () => handleSelect('device')
        },
        {
          text: 'Youtube',
          icon: logoYoutube,
          handler: () => handleSelect('youtube')
        }
      ]}
    />
  );
};
